<template>
  <div>
    <el-table :data="paginatedCustomers" style="width: 100%" stripe border>
      <div slot="empty">
        Aucune donnée
      </div>
      <el-table-column label="Nom">
        <template slot-scope="scope">
          <customer :item="scope.row"></customer>
        </template>
      </el-table-column>
      <el-table-column label="Suivi commercial">
        <template slot-scope="scope">
          <div v-if="loadingReminders">
            <pulse-loader color="#cccccc" size="8px"></pulse-loader>
          </div>
          <div v-else>
            <div v-if="models.reminders.find(reminder => reminder.customer_id === scope.row.id)">
              <reminder :item="models.reminders.find(reminder => reminder.customer_id === scope.row.id)"></reminder>
              (<user :item="users.find(user => user.id === models.reminders.find(reminder => reminder.customer_id === scope.row.id).user_id)"></user>)
            </div>
          </div>
          <div class="text-muted font-13">
            <strong>Dans le parc de </strong> :
            <span v-if="scope.row.user_id">
                    <user :item="users.find(user => user.id === scope.row.user_id)"></user>
                  </span>
            <span v-else>
                    Aucun
                  </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Dernier contact">
        <template slot-scope="scope">
          <div v-if="loadingCalls">
            <pulse-loader color="#cccccc" size="8px"></pulse-loader>
          </div>
          <div v-else>
            <last-call-widget :last_call="models.calls.filter(call => call.customer_id === scope.row.id).pop()" ></last-call-widget>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Contacts">
        <template slot-scope="scope">
          <customer present="contacts" :item="scope.row"></customer>
        </template>
      </el-table-column>
      <el-table-column label="Services">
        <template slot-scope="scope">
          <customer present="services" :item="scope.row"></customer>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="pagination.current_page"
      :page-size="pagination.per_page"
      layout="total, prev, pager, next"
      :total="pagination.total"
       @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<script>
  import CustomerSearchForm from '@db2b/keystone/components/Entities/Forms/CustomerSearchForm.vue'
  import Customer from '@db2b/keystone/components/Entities/Customer.vue'
  import _ from 'lodash'
  import Reminder from '@db2b/keystone/components/Entities/Reminder.vue'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import User from '@db2b/keystone/components/Entities/User.vue'
  import LastCall from '@db2b/keystone/components/Widgets/Calls/LastCall.vue'

  export default {
    name: 'customers-table',
    components: {
      User,
      Reminder,
      CustomerSearchForm,
      Customer,
      PulseLoader,
      'last-call-widget': LastCall
    },
    props: ['customers', 'pagination'],
    data () {
      return {
        models: {
          reminders: [],
          calls: [],
        },
        loadingReminders: false,
        loadingCalls: false,
        page: {
          number: 1,
          size: 20
        }
      }
    },
    sync: {
      models: {
        reminders: 'reminder'
      }
    },
    computed: {
      paginatedCustomers () {
        let start = (this.page.number - 1) * this.page.size
        let end = start + this.page.size

        return _.slice(this.customers, start, end)
      },
      users () {
        return this.$store.getters['users/all']
      }
    },
    watch: {
      paginatedCustomers (customers) {
        let self = this

        self.loadingReminders = true
        this.$nexus.get('callcenter', 'reminders', {
          params: {
            where: {
              customer_id: {
                'IN': customers.map(customer => customer.id).join(',')
              }
            }
          }
        }).then(response => {
          self.models.reminders = response.data.data
          self.loadingReminders = false
        })

        self.loadingCalls = true
        this.$nexus.get('callcenter', 'calls', {
          params: {
            where: {
              customer_id: {
                'IN': customers.map(customer => customer.id).join(',')
              }
            }
          }
        }).then(response => {
          self.models.calls = response.data.data
          self.loadingCalls = false
        })
      }
    },
    methods: {
      currentChange (page) {
        this.$emit('changePage', {page})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomersTable.vue?70c9babe